import { render } from "./DrawerButton.vue?vue&type=template&id=48030b9d"
import script from "./DrawerButton.vue?vue&type=script&lang=js"
export * from "./DrawerButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__